import React, {Component} from 'react';
import PropTypes from 'prop-types';
import GeneralUtils from "../../utils/GeneralUtils";
import PageSettingsService from "../../service/PageSettingsService";
import {Menubar} from 'primereact/menubar';
import MerchantBranchService from "../../service/MerchantBranchService";
import {withRouter} from 'react-router-dom';
import './AppTopbarMember.css';
import EnvironmentBanner from './EnvironmentBanner';

export   class AppTopbarMember extends Component {
    constructor(props) {
        super(props);

        this.state = {
            noticeCount: 0,
            header: null,
            homeName: 'Home',
            domainName: null,
            userMenuOpen: false
        };
        this.pageSettingsService = new PageSettingsService();
        this.merchantBranchService = new MerchantBranchService();
        this.userMenuRef = React.createRef();
        this.handleDocumentClick = this.handleDocumentClick.bind(this);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleDocumentClick);
        document.removeEventListener('touchstart', this.handleDocumentClick);
    }

    handleDocumentClick(event) {
        if (!this.state.userMenuOpen) {
            return;
        }
        if (this.userMenuRef.current && !this.userMenuRef.current.contains(event.target)) {
            this.setState({userMenuOpen: false});
        }
    }

    toggleUserMenu = () => {
        const nextOpen = !this.state.userMenuOpen;
        this.setState({userMenuOpen: nextOpen});
        if (nextOpen) {
            document.addEventListener('mousedown', this.handleDocumentClick);
            document.addEventListener('touchstart', this.handleDocumentClick);
        } else {
            document.removeEventListener('mousedown', this.handleDocumentClick);
            document.removeEventListener('touchstart', this.handleDocumentClick);
        }
    }

    closeUserMenu = () => {
        document.removeEventListener('mousedown', this.handleDocumentClick);
        document.removeEventListener('touchstart', this.handleDocumentClick);
        this.setState({userMenuOpen: false});
    }

    getUserInitials() {
        try {
            const hsmUser = JSON.parse(localStorage.getItem("hsmUser"));
            if (hsmUser) {
                const first = (hsmUser.firstName || '').trim();
                const last = (hsmUser.lastName || '').trim();
                if (first && last) {
                    return (first.charAt(0) + last.charAt(0)).toUpperCase();
                }
                if (first) {
                    return first.charAt(0).toUpperCase();
                }
                if (last) {
                    return last.charAt(0).toUpperCase();
                }
            }
        } catch (e) {
            // ignore parse errors
        }
        const firstName = GeneralUtils.getFirstName();
        if (!GeneralUtils.isNullOrEmpty(firstName)) {
            return firstName.trim().charAt(0).toUpperCase();
        }
        const userName = GeneralUtils.getUserName();
        if (!GeneralUtils.isNullOrEmpty(userName) && userName.trim()) {
            const trimmed = userName.trim();
            if (trimmed.indexOf('@') > 0) {
                return trimmed.charAt(0).toUpperCase();
            }
            return trimmed.charAt(0).toUpperCase();
        }
        return '?';
    }

    getUserDisplayName() {
        const fullName = GeneralUtils.getUserNameAndFamilyNames();
        if (!GeneralUtils.isNullOrEmpty(fullName) && fullName.trim()) {
            return fullName.trim();
        }
        const firstName = GeneralUtils.getFirstName();
        if (!GeneralUtils.isNullOrEmpty(firstName)) {
            return firstName.trim();
        }
        const userName = GeneralUtils.getUserName();
        if (GeneralUtils.isNullOrEmpty(userName)) {
            return 'My account';
        }
        return userName.trim();
    }

    getUserMenuItems() {
        return [
            {label: 'Account Details', icon: 'pi pi-user', path: '/accountDetails'},
            {label: 'Payment Methods', icon: 'pi pi-money-bill', path: '/paymentMethods'},
            {label: 'Addresses', icon: 'pi pi-map-marker', path: '/address'},
            {label: 'Orders', icon: 'pi pi-shopping-cart', path: '/myOrders'},
            {label: 'Complaint / Suggestion', icon: 'pi pi-comment', path: '/complaintSuggestion'},
            {
                label: 'Log out',
                icon: 'pi pi-sign-out',
                danger: true,
                action: () => {
                    localStorage.removeItem(localStorage.getItem("merchantBranchId"));
                    this.props.logout();
                }
            }
        ];
    }

    onUserMenuItemClick(item) {
        this.closeUserMenu();
        if (item.action) {
            item.action();
            return;
        }
        if (item.path) {
            window.location.href = item.path;
        }
    }

    renderUserMenu() {
        const displayName = this.getUserDisplayName();
        const initials = this.getUserInitials();
        const menuItems = this.getUserMenuItems();

        return (
            <div ref={this.userMenuRef} className="member-user-menu">
                <button
                    type="button"
                    className="member-user-menu__trigger member-user-menu__trigger--avatar-only"
                    aria-expanded={this.state.userMenuOpen}
                    aria-haspopup="true"
                    aria-label={displayName || 'Account menu'}
                    title={displayName || 'Account menu'}
                    onClick={this.toggleUserMenu}
                >
                    <span className="member-user-menu__avatar" aria-hidden="true">{initials}</span>
                </button>
                {this.state.userMenuOpen &&
                    <div className="member-user-menu__panel" role="menu">
                        {menuItems.map((item, index) => (
                            <React.Fragment key={item.label}>
                                {item.danger && <div className="member-user-menu__divider"/>}
                                <button
                                    type="button"
                                    role="menuitem"
                                    className={`member-user-menu__item${item.danger ? ' member-user-menu__item--danger' : ''}`}
                                    onClick={() => this.onUserMenuItemClick(item)}
                                >
                                    <i className={`${item.icon} member-user-menu__item-icon`} aria-hidden="true"/>
                                    <span>{item.label}</span>
                                </button>
                            </React.Fragment>
                        ))}
                    </div>
                }
            </div>
        );
    }


    componentDidMount = async () => {
        let branchName = GeneralUtils.getDomainName();
        if (!GeneralUtils.isNullOrEmpty(branchName) && branchName!="admin") {
                const response = (await this.merchantBranchService.getBranchIdByDomainName(branchName));
                if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type) && response != 0) {
                    localStorage.setItem("merchantBranchId", response);
                    this.getImageAndBusinessName(response);
                } else {
                    this.getImageAndBusinessName(-1);
                }



        } else {
            this.getImageAndBusinessName(-1);
        }
    }

    setMarketPlaceHeader(){
        if (GeneralUtils.isMobile()) {
            this.setState({header: "assets/layout/images/marketplace_mobile.png"});
        } else {
            this.setState({header: "assets/layout/images/marketplace_web.png"});
        }
    }

    getImageAndBusinessName(merchantBranchId) {
        if (GeneralUtils.isNullOrEmpty(GeneralUtils.getDomainName()) || merchantBranchId == -1) {
            GeneralUtils.clearMemberStoreNames();
           this.setMarketPlaceHeader()

        } else {

            if (!GeneralUtils.isNullOrEmpty(merchantBranchId)) {
                this.merchantBranchService.getStoreInfo(merchantBranchId).then(response => {
                        if (!GeneralUtils.isNullOrEmpty(response) && GeneralUtils.isNullOrEmpty(response.type)) {
                            const tradingName = response.tradingName != null ? String(response.tradingName).trim() : '';
                            const businessName = response.businessName != null ? String(response.businessName).trim() : '';
                            if (tradingName) {
                                this.setState({homeName: tradingName, domainName: response.domainName});
                            }
                            GeneralUtils.persistMemberStoreNamesFromStoreInfo(response);

                        }
                    }
                )
            }

            if (!GeneralUtils.isNullOrEmpty(merchantBranchId)) {
                let imageType = GeneralUtils.isMobile() ? "MOBILE" : "HEADER";
                this.setState({header: this.pageSettingsService.getImageUrl(merchantBranchId, imageType)});
            }

        }
    }


    render() {
        var items = [];
        const onWebMarketUrl = GeneralUtils.isServedInWebMarketUrl();
        if (!GeneralUtils.isNullOrEmpty(GeneralUtils.getDomainName())) {
            if (!onWebMarketUrl) {
                items.push({
                    label: this.state.homeName,
                    icon: 'pi pi-fw pi-home',
                    command: (e) => {
                        this.setState({loading: true});
                        if (this.state.homeName == "Home") {
                            window.location.href = '/';
                        } else {
                            window.location.href = '/';
                        }
                    }
                });
            }

            if (onWebMarketUrl) {
                items.push({
                    label: 'Market Place',
                    icon: 'pi pi-fw pi-th-large',
                    command: (e) => {
                        localStorage.setItem("merchantBranchId", -1);
                        GeneralUtils.clearMemberStoreNames();
                        this.setMarketPlaceHeader();
                        window.location.href = "/";
                    }
                });
            }
        }

        const isAuthenticated = GeneralUtils.isAuthenticated();
        let navItems = [];
        if (isAuthenticated) {
            navItems = items;
        } else {
            navItems = items.slice();
            navItems.push({
                label: "Login",
                icon: 'pi pi-fw pi-user',
                command: () => {
                    window.location.href = "/login";
                }
            });
        }

        let height = 360;
        let width = "105%";
        let maxWidth = "1900px";
        let marginRight = "20px"
        if (GeneralUtils.isMobile()) {
            height = 300;
            width = "100%"
            maxWidth = "100%";
            marginRight = "2px";
        }

        return (
            <div className="member-topbar-wrap">
                    <div>

                        <EnvironmentBanner />

                        <div className="member-topbar-toolbar" style={{paddingRight: marginRight, paddingLeft: marginRight}}>
                            <div className="member-topbar-nav">
                                {navItems.length > 0 &&
                                    <Menubar className="member-topbar-menubar" model={navItems}/>
                                }
                            </div>
                            {isAuthenticated &&
                                <div className="member-topbar-user-slot">
                                    {this.renderUserMenu()}
                                </div>
                            }
                        </div>

                    </div>

                    {this.state.header != null &&
                        <div className="member-topbar-header">
                            <img
                                src={this.state.header}
                                onError={(e) => this.setMarketPlaceHeader()}
                                width={width}
                                height={height + "px"}
                                maxWidth={maxWidth}
                                alt=""
                            />
                        </div>
                    }
            </div>
        )
            ;
    }
}

AppTopbarMember
    .propTypes = {
    onToggleMenu: PropTypes.func.isRequired,
    logout: PropTypes.func
};

AppTopbarMember
    .defaultProps = {
    onToggleMenu: null
};

withRouter(AppTopbarMember);
